// extracted by mini-css-extract-plugin
module.exports = {"root":"menu-item-trailing_root___HECX","current":"menu-item-trailing_current__QRNZa","check":"menu-item-trailing_check__Yl_Mg","icon":"menu-item-trailing_icon__rwfZ_"};